import { lddGlobalSessionInfo, NavObjectType } from "../../Components/navigationTypes";

export type DRListModalType = "inbox" | "infile" | "mortgage";

export function isPageInDR(page: NavObjectType): boolean {
    if (!page) return false;
    if (page.component === 'dr') return true;
    return isPageInDrFile(page);
}

export function isPageInDrFile(page: NavObjectType): boolean {
    if (page.component === 'main' && page.params?.type === 'file' && page.params?.id) {
        return true;
    }
    return false;
}

export function isPageInDrPasscodeFile(page: NavObjectType): boolean {
    if (page.component === 'main' && page.params?.type === 'file' && page.params?.id && page.params?.PassCode > "") {
        return true;
    }
    return false;
}

export function launchLDDzoho(url: string, SessionInfo: lddGlobalSessionInfo, adId: string) {
    const params = new URLSearchParams();
    if (SessionInfo) {
        if (SessionInfo.user.firstname) params.append('first_name', SessionInfo.user.firstname);
        if (SessionInfo.user.lastname) params.append('last_name', SessionInfo.user.lastname);
        if (SessionInfo.user.email) params.append('email', SessionInfo.user.email);
        if (SessionInfo.firm.name) params.append('a1', SessionInfo.firm.name);
        if (SessionInfo.user.phone) params.append('phone', SessionInfo.user.phone);
        if (SessionInfo.firm.account) params.append('acc_name', SessionInfo.firm.account);
        if (SessionInfo.firm.id) params.append('acc_id', SessionInfo.firm.id.toString());
        if (SessionInfo.appProvinceShort) params.append('province', SessionInfo.appProvinceShort);
    }
    if (adId) {
        params.append('ad_id', adId);
    }

    url = `${url}${params.toString() ? '?' + params.toString() : ''}`;
    window.open(url, "_blank");
}

/**
 * Login with a passcode and return the MsgID
 * @param passCode 
 * @returns MsgID
 */
export async function loginWithPassCode(passCode: string): Promise<string> {
    var mts = passCode.match(/^[a-zA-Z0-9]{5}-[a-zA-Z0-9]{5}-[a-zA-Z0-9]{5}-[a-zA-Z0-9]{5}$/);
    if (!mts || mts.length != 1 || mts[0] != passCode) {
        throw new Error("Invalid deal code");
    }
    const res = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/passcode/login?PassCode=${passCode}`);
    if (!res.ok) {
        const resText = await res.text();
        throw new Error(resText); 
    }
    const responsesJSON = await res.json();
    if (responsesJSON?.result?.MsgID) {
        return responsesJSON.result.MsgID;
    } else {
        throw new Error("Invalid deal code, or no documents have been posted. Check back later or contact the vendor's solicitor.");
    }
}

export async function importDealCode(dealCode: string, ModalType: DRListModalType, appID: string, nav: (navObject: NavObjectType) => void) {
    try {
        const msgID: string = await loginWithPassCode(dealCode);
        // if in rpw, show fuzzy match
        if (ModalType == "infile") {
            let navObj: NavObjectType;
            if (appID > "") {
                // nav to purfileedit
                navObj = {
                    component: "main",
                    url: "lfmaster.asp",
                    controller: {
                        tabName: "NewHome",
                    },
                    params: {
                        formasp: "purfileedit",
                        tb: "TPAppXML",
                        id: appID,
                        onload: `MergeVIPInfoNode(${msgID},"${dealCode}");SetPageDirty();`,
                        PassCode: '1',
                    },
                    label: "Import Information",
                    reactFrame: "builderinfo",
                    init: true,
                }
            }
            nav(navObj);
        } else if (!ModalType) { // in standalone dr
            let navObj: NavObjectType = {
                component: 'main',
                label: "Documents",
                reactFrame: "builderdoc",
                params: {
                    'type': 'file',
                    'id': msgID,
                    'PassCode': '1'
                },
            };
            nav(navObj);
        }
    } catch (error) {
        throw error;
    }
    
}